import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';

const AppointmentFilters = ({ filters, onFiltersChange, appointmentsCount }) => {
  const propertyTypeOptions = [
    { value: 'all', label: 'جميع الأنواع' },
    { value: 'apartment', label: 'شقة' },
    { value: 'villa', label: 'فيلا' },
    { value: 'office', label: 'مكتب' },
    { value: 'shop', label: 'محل تجاري' },
    { value: 'land', label: 'أرض' }
  ];

  const staffOptions = [
    { value: 'all', label: 'جميع الموظفين' },
    { value: 'staff001', label: 'محمد السعيد' },
    { value: 'staff002', label: 'خالد الغامدي' },
    { value: 'staff003', label: 'أحمد السعيد' },
    { value: 'staff004', label: 'عبدالله الشمري' }
  ];

  const statusOptions = [
    { value: 'all', label: 'جميع الحالات' },
    { value: 'confirmed', label: 'مؤكد' },
    { value: 'pending', label: 'قيد الانتظار' },
    { value: 'cancelled', label: 'ملغي' }
  ];

  const quickActions = [
    { label: 'مواعيد اليوم', icon: 'Calendar', count: 3 },
    { label: 'مواعيد الأسبوع', icon: 'CalendarDays', count: 12 },
    { label: 'مواعيد معلقة', icon: 'Clock', count: 5 },
    { label: 'مواعيد مؤكدة', icon: 'CheckCircle', count: 8 }
  ];

  return (
    <div className="space-y-4">
      {/* Filters Card */}
      <div className="bg-card rounded-lg border border-border p-4">
        <div className="flex items-center gap-2 mb-4">
          <Icon name="Filter" size={20} className="text-primary" />
          <h3 className="text-lg font-heading font-semibold text-foreground">
            تصفية المواعيد
          </h3>
        </div>

        <div className="space-y-3">
          <Select
            label="نوع العقار"
            options={propertyTypeOptions}
            value={filters?.propertyType}
            onChange={(value) => onFiltersChange({ ...filters, propertyType: value })}
          />

          <Select
            label="الموظف المسؤول"
            options={staffOptions}
            value={filters?.staffMember}
            onChange={(value) => onFiltersChange({ ...filters, staffMember: value })}
          />

          <Select
            label="حالة الموعد"
            options={statusOptions}
            value={filters?.clientStatus}
            onChange={(value) => onFiltersChange({ ...filters, clientStatus: value })}
          />
        </div>

        <div className="mt-4 pt-4 border-t border-border">
          <div className="flex items-center justify-between">
            <span className="text-sm text-muted-foreground">النتائج</span>
            <span className="text-lg font-bold text-primary">{appointmentsCount}</span>
          </div>
        </div>
      </div>

      {/* Quick Actions */}
      <div className="bg-card rounded-lg border border-border p-4">
        <h3 className="text-sm font-semibold text-foreground mb-3">
          إجراءات سريعة
        </h3>
        <div className="space-y-2">
          {quickActions?.map((action, idx) => (
            <button
              key={idx}
              className="w-full flex items-center justify-between p-3 rounded-lg hover:bg-muted/50 transition-colors text-right"
            >
              <div className="flex items-center gap-2">
                <Icon name={action?.icon} size={18} className="text-primary" />
                <span className="text-sm font-medium text-foreground">{action?.label}</span>
              </div>
              <span className="text-sm font-bold text-primary">{action?.count}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Legend */}
      <div className="bg-card rounded-lg border border-border p-4">
        <h3 className="text-sm font-semibold text-foreground mb-3">
          دليل الألوان
        </h3>
        <div className="space-y-2">
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 rounded bg-success/20 border border-success/30" />
            <span className="text-xs text-muted-foreground">مؤكد</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 rounded bg-warning/20 border border-warning/30" />
            <span className="text-xs text-muted-foreground">قيد الانتظار</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 rounded bg-error/20 border border-error/30" />
            <span className="text-xs text-muted-foreground">ملغي</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppointmentFilters;